export class ApiError extends Error {
  constructor(status, message, reauthenticate = false) { super(message); this.status = status; this.reauthenticate = reauthenticate; }
}

export async function api(path, { body, signal, method = body === undefined ? 'GET' : 'POST' } = {}) {
  const response = await fetch(path, {
    method, credentials: 'same-origin',
    headers: { Accept: 'application/json', ...(body === undefined ? {} : { 'Content-Type': 'application/json' }) },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    signal: signal ? AbortSignal.any([signal, AbortSignal.timeout(30000)]) : AbortSignal.timeout(30000),
  });
  if (response.status === 204) return null;
  const data = await response.json().catch(() => null);
  if (!response.ok) throw new ApiError(response.status, data?.message || 'The request could not be completed. Please try again.', data?.reauthenticate === true);
  return data;
}
